var _rect, _g, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlinkAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 18,
    viewBox: "0 0 66 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 18,
    rx: 2,
    fill: "#fa0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.555 2.055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.4,16.648a2.676,2.676,0,0,1-2.7-2.7,2.535,2.535,0,0,1,.811-1.892L4.4,10.162a.535.535,0,0,1,.757.757L3.267,12.811a1.606,1.606,0,0,0,2.27,2.27l1.892-1.892a.535.535,0,1,1,.757.757L6.294,15.837a2.535,2.535,0,0,1-1.892.811Z",
    transform: "translate(-0.322 -4.136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.567,8.488a.511.511,0,0,1-.54-.54.491.491,0,0,1,.162-.378l1.892-1.892a1.606,1.606,0,0,0-2.27-2.27L10.919,5.3a.535.535,0,0,1-.757-.757l1.892-1.892a2.724,2.724,0,0,1,3.837.054,2.642,2.642,0,0,1,0,3.729L14,8.326a.719.719,0,0,1-.432.162Z",
    transform: "translate(-4.136 -0.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.54,3.162A.511.511,0,0,1,7,2.621V1.54a.54.54,0,1,1,1.081,0V2.621A.511.511,0,0,1,7.54,3.162Z",
    transform: "translate(-2.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.621,8.081H1.54A.54.54,0,1,1,1.54,7H2.621a.54.54,0,1,1,0,1.081Z",
    transform: "translate(0 -2.757)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.621,4.162A.491.491,0,0,1,3.243,4L2.162,2.919a.535.535,0,0,1,.757-.757L4,3.243A.522.522,0,0,1,4,4,.491.491,0,0,1,3.621,4.162Z",
    transform: "translate(-0.46 -0.46)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.621,16.081H19.54a.54.54,0,0,1,0-1.081h1.081a.54.54,0,0,1,0,1.081Z",
    transform: "translate(-8.271 -6.433)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.54,21.162a.511.511,0,0,1-.54-.54V19.54a.54.54,0,0,1,1.081,0v1.081A.511.511,0,0,1,15.54,21.162Z",
    transform: "translate(-6.433 -8.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.621,20.162A.491.491,0,0,1,19.243,20l-1.081-1.081a.535.535,0,0,1,.757-.757L20,19.243A.522.522,0,0,1,20,20,.491.491,0,0,1,19.621,20.162Z",
    transform: "translate(-7.812 -7.812)",
    fill: "#fff"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(40.25 13.5)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -21.067,
    y: 0
  }, "UNLINK"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlinkAllIcon);
export default __webpack_public_path__ + "static/media/UnlinkAll_Icon.8aafc79e43abec31f053050f03ec2f9b.svg";
export { ForwardRef as ReactComponent };